import { useT } from '_metronic/i18n/Metronici18n'
import { IconPaths } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { SearchPersonModal } from '../../../../../../components/Modal/SearchPersonModal'

export const UsersListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const handleOpenModal = () =>
    showModal({
      title: 'Localizar Paciente',
      content: <SearchPersonModal />,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={handleOpenModal}>
      {t('common.add')}
    </Button>
  )
}
